import React from 'react';

import { useIntl } from 'react-intl';

import { useLocale } from 'state/intl';
import { REGIONS } from 'state/intl/types';

import { Total, TotalLabel, TotalsRow } from './styled';

const TaxesAndFeesNextStep: React.FC = () => {
  const { region } = useLocale();
  const { formatMessage } = useIntl();

  if (region === REGIONS.GB) {
    return null;
  }

  return (
    <TotalsRow>
      <TotalLabel>
        {formatMessage({
          id: 'taxesAndFees',
        })}
      </TotalLabel>
      <Total data-testid="totalTax">
        {formatMessage({
          id: 'taxesAndFeesNextStep',
        })}
      </Total>
    </TotalsRow>
  );
};

export default TaxesAndFeesNextStep;
